import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Problem, Service, WhyUs } from "@/components/landing/Sections";
import { Pricing } from "@/components/landing/Pricing";
import { BeforeAfter } from "@/components/landing/BeforeAfter";
import { Faq, Process } from "@/components/landing/Faq";
import { Contact, Footer, StickyWhatsApp } from "@/components/landing/Contact";

const LandingPage = () => (
    <div className="min-h-screen bg-cream font-body text-ink">
        <Header />
        <main>
            <Hero />
            <Problem />
            <Service />
            <Pricing />
            <BeforeAfter />
            <WhyUs />
            <Process />
            <Faq />
            <Contact />
        </main>
        <Footer />
        <StickyWhatsApp />
    </div>
);

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LandingPage />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
